import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Analytics } from '@vercel/analytics/react';
// Add this after importing Analytics in main.tsx or at the top of App.tsx
// Make sure @vercel/analytics is v1.1.0 or higher
import { track } from '@vercel/analytics';

// Or use the va() function if you don't want to import:
// window.va('event', { name: 'EventName', data: { property: 'value' } });
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <Analytics />
  </React.StrictMode>
);